module.exports = __webpack_public_path__ + "img/TeodoroLocsinMessage_home.df4d8f0c.jpg";